<template>
  <selectable-tiles
    :items="predefinedSegments"
    :should-display-labels="true"
    :should-display-icons="true"
    :should-display-checkmark-on-selected-items="!props.isReadOnly"
    label-property-name="name"
    description-property-name="description"
    icon-property-name="icon"
    :icon-size="iconSize"
    :tile-padding="small ? '1rem' : null"
    :selected-items="selectedPredefinedSegments"
    :is-multiselect="false"
    :is-read-only="props.isReadOnly"
    :allow-empty="true"
    :justify-content-left="true"
    separator-height="1rem"
    @selection-changed="selectDemographic" />
</template>

<script setup lang="ts">
  import { computed, onUnmounted } from 'vue';

  import SelectableTiles from '@/common/components/controls/SelectableTiles.vue';
  import ScentrePredefinedSegment from '@/common/components/targeting/scentre/ScentrePredefinedSegment';
  import { Demographic } from '@/common/models';

  interface Props {
    isReadOnly: boolean;
    demographics: Demographic[];
    selectedDemographic: Demographic[];
    small: boolean;
  }

  enum Emits {
    CHANGE = 'onChange',
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{ (e: Emits.CHANGE, demographic: Demographic): void }>();

  const predefinedSegments = computed(() => props.demographics?.map((d) => new ScentrePredefinedSegment(d)) || []);
  const selectedPredefinedSegments = computed(
    () => props.selectedDemographic?.map((d) => new ScentrePredefinedSegment(d)) || [],
  );

  const iconSize = computed(() => `${props.isReadOnly ? '12' : props.small ? '10' : '18'}rem`);

  function selectDemographic(selectedDemographics: ScentrePredefinedSegment[]): void {
    const demo =
      selectedDemographics[0].demographic?.id === props.selectedDemographic?.[0]?.id
        ? null
        : selectedDemographics[0].demographic;
    emit(Emits.CHANGE, demo);
  }

  onUnmounted(() => {
    // clear data
    emit(Emits.CHANGE, null);
  });
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;
</style>
